"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var TimeOffFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_TimeOffFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 0a.5.5 0 0 1 .5.5V3a.5.5 0 0 1-1 0V.5A.5.5 0 0 1 5 0ZM11 0a.5.5 0 0 1 .5.5V3a.5.5 0 0 1-1 0V.5A.5.5 0 0 1 11 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 1h3v2a1.5 1.5 0 0 0 3 0V1.009c.865.02 1.412.089 1.862.318a3 3 0 0 1 1.311 1.311c.27.53.317 1.197.325 2.362H.002C.01 3.835.057 3.169.327 2.638a3 3 0 0 1 1.311-1.311c.45-.23.997-.298 1.862-.318V3a1.5 1.5 0 1 0 3 0V1ZM0 6v5.2c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C2.28 16 3.12 16 4.8 16h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C16 13.72 16 12.88 16 11.2V6H0Zm5.646 2.146a.5.5 0 0 1 .708 0L8 9.793l1.646-1.647a.5.5 0 0 1 .708.708L8.707 10.5l1.647 1.646a.5.5 0 0 1-.708.708L8 11.207l-1.646 1.647a.5.5 0 0 1-.708-.708L7.293 10.5 5.646 8.854a.5.5 0 0 1 0-.708Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_TimeOffFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = TimeOffFill;
exports["default"] = _default;